export const API_ENDPOINTS = {
    AUTH: {
        LOGIN: '/user/login',
        LOGOUT: '/auth/logout',
        PROFILE: '/auth/profile',
        SET_PASSWORD: '/auth/set-password'
    },
    ACCOUNT: {
        GET_ACCOUNT: '/account',
        UPDATE_ACCOUNT: '/account',
        DEBTOR_REGISTRATION: '/account/debtors'
    },
    DEBTOR: {
        LIST: '/debtor-view',
        DETAIL: (id: string | number) => `/debtor-view/${id}`, // For list compatibility
        DETAIL_PROFILE: (id: string | number) => `/debtor/${id}`, // For full profile/anagrafica (apiBasePath already includes /a)
        UPDATE: (id: string | number) => `/debtor/${id}`, // Update debtor profile (apiBasePath already includes /a)
        PARAMETERS: (id: string | number) => `/debtor/${id}/parameters`, // Parameters endpoint
        LENDERS: (debtorId: string | number) => `/debtor/${debtorId}/lender`, // List lenders for a debtor (paginated)
        CREATE_LENDER_RELATIONSHIP: (debtorId: string | number, lenderId: string | number) => `/debtor/${debtorId}/lender/${lenderId}`, // Create debtor-lender relationship
        UPDATE_LENDER_RELATIONSHIP: (debtorId: string | number, lenderId: string | number) => `/debtor/${debtorId}/lender/${lenderId}` // Update debtor-lender relationship
    },
    DOCUMENTS: {
        ROOT: '/documents',
        UPLOAD: '/documents/upload',
        DOWNLOAD: '/documents/download'
    },
    ADVANCES: {
        ROOT: '/advances',
        EXPORT: '/advances/export',
        EXPORT_REQUESTS: '/invoice/requests/export',
        DETAIL: (id: string | number) => `/advances/${id}`
    },
    LENDERS: {
        LIST: '/lenders'
    },
    INVOICE: {
        LIST_ALL: (fullTaxCode: string) => `/invoice/${fullTaxCode}/all`,
        DETAIL: (id: string) => `/invoice/${id}`,
        DOWNLOAD: (id: string) => `/invoice/${id}/download`,
        UPDATE_STATUS: (id: string) => `/invoice/${id}/status`,
        CREATE_ATTACHMENT: (id: string) => `/invoice/${id}/attachment`,
        CREATE_EMPTY_ATTACHMENT: (id: string) => `/invoice/${id}/attachment/empty`,
        LIST_ATTACHMENTS: (id: string) => `/invoice/${id}/attachment`,
        DOWNLOAD_ATTACHMENT: (id: string, attachmentId: number) => `/invoice/${id}/attachment/${attachmentId}`,
        UPDATE_ATTACHMENT: (id: string, attachmentId: number) => `/invoice/${id}/attachment/${attachmentId}`,
        DELETE_ATTACHMENT: (id: string, attachmentId: number) => `/invoice/${id}/attachment/${attachmentId}`
    },
    INVOICE_ATTACHMENT_TYPE: {
        LIST: '/invoice-attachment-type',
        UPDATE: '/invoice-attachment-type'
    },
    FSM: {
        COMPANY_STATUS: '/fsm/company-status',
        TRANSITIONS: '/fsm/transition',
        TRANSITION_DETAIL: (transitionId: number) => `/fsm/transition/${transitionId}`,
        TRANSITION_REASONS: '/fsm/transition/reasons',
        EXECUTE_TRANSITION: (transitionId: number, debtorId: string | number) =>
            `/fsm/transition/${transitionId}/debtor/${debtorId}`
    },
    USER: {
        LIST: '/user',
        ALL: '/user/all',
        DETAIL: (id: string | number) => `/user/${id}`,
        CREATE: '/user',
        UPDATE: (id: string | number) => `/user/${id}`,
        CHANGE_PASSWORD: '/user/change-password',
        CHANGE_PASSWORD_BY_ID: (id: string | number) => `/user/${id}/change-password`,
        ROLES: '/user/roles',
        ME: '/user/me'
    },
    SUPPLIER: {
        ALL: '/c/supplier/all' // Note: uses /api/c/ instead of /api/a/
    },
    TICKETS: {
        ROOT: '/tickets',
        LIST: '/tickets',
        DETAIL: (id: number) => `/tickets/${id}`,
        ASSIGNEE: (id: number) => `/tickets/${id}/assignee`,
        ASSIGNEE_BULK: '/tickets/assignee',
        COMMENTS: (ticketId: number) => `/tickets/${ticketId}/comments`,
        COMMENTS_BULK: '/tickets/comments',
        COMMENT_DETAIL: (ticketId: number, commentId: number) => `/tickets/${ticketId}/comments/${commentId}`,
        CATEGORIES: '/tickets/categories',
        STATUS: '/tickets/status',
        PRIORITIES: '/tickets/priorities',
        REFERENCES: '/tickets/references',
        OUTCOMES: '/tickets/outcomes',
        TICKET_OUTCOMES: (id: number) => `/tickets/${id}/outcomes`,
        TITLES: '/tickets/titles',
        BY_STATUS: '/tickets/by-status',
        EXPIRATIONS_BULK: '/tickets/expirations',
        STATUSES_BULK: '/tickets/statuses'
    }
} as const;



